import { render, staticRenderFns } from "./iframe-box.vue?vue&type=template&id=0f3bd030&scoped=true&"
import script from "./iframe-box.vue?vue&type=script&lang=js&"
export * from "./iframe-box.vue?vue&type=script&lang=js&"
import style0 from "./iframe-box.vue?vue&type=style&index=0&id=0f3bd030&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3bd030",
  null
  
)

export default component.exports